export const createUniqueId = () => Math.random().toString(16).substring(2);
